// extracted by mini-css-extract-plugin
module.exports = {"link-container":"_6bf55ce5dc--link-container--b6BMy","link":"_6bf55ce5dc--link--k9NUU"};